import { getMessage } from 'common/helpers/miscHelper';

const Message = (props) => {
  const { settings } = props;
  return (
    <div
      className="c7-message c7-message--checkout-legal"
      dangerouslySetInnerHTML={{
        __html: getMessage('Checkout Message', settings)
      }}
    />
  );
};

export default Message;
